import * as url from "../url.helper";

import { post } from "../api.helper";

export const submitFinancierPref = data => post(url.ADD_FINANCIER_PREFERENCE, data);
export const listFinancierPref = data => post(url.LIST_FINANCIER_PREFERENCE, data);
export const updateFinancierPref = data => post(url.UPDATE_FINANCIER_PREFERENCE, data);
export const deleteFinancierPref = data => post(url.DELETE_FINANCIER_PREFERENCE, data);
export const getFinancierPref = data => post(url.GET_FINANCIER_PREFERENCE, data);



